module.exports = __webpack_public_path__ + "img/Tenable-Nessus.591a08f.svg";